// extracted by mini-css-extract-plugin
export var wrapper = "GitHubButton-module--wrapper--fbe84";